import React from 'react'

import Footer from '@components/Footer'

import { Facebook, Instagram, Youtube } from '@assets/icons'

export default function HomeFooter() {
  const links = [
    {
      url: 'https://www.gympass.com/us',
      label: 'smb_acquisition_footer.call_to_action.home',
    },
  ]

  const social = [
    {
      url: 'https://www.facebook.com/GympassUS',
      icon: Facebook,
      alt: 'facebook-link',
    },
    {
      url: 'https://www.instagram.com/gympass_usa',
      icon: Instagram,
      alt: 'instagram-link',
    },
    {
      url: 'https://www.youtube.com/channel/UCTNRunlqGLZQK8HNRDze6bg',
      icon: Youtube,
      alt: 'youtube-link',
    },
  ]

  return <Footer links={links} social={social} company="Gympass B.V." />
}
